import React, {useContext, useMemo, useState} from "react";
import CreateNewMessageModal from "../Components/MessageCentre/Modals/CreateNewMessageModal";
import PDFViewerModal from "../Components/PDFViewerModal";

interface iSiteProvider {
    togglePDFViewer?: any;
    toggleSiteMessage?: any;
    siteContactOpen?: boolean;
    pDFViewerDetails?: any;
}

const SiteContext = React.createContext<iSiteProvider>({} as iSiteProvider);

const SiteProvider = (props: any) => {
    const [ siteContactOpen, setSiteContactOpen ] = useState<boolean>(false);
    const [ pDFViewerDetails, setPDFViewerDetails ] = useState<any>({ open: false, uri: '' });

    const toggleSiteMessage = () => {
        setSiteContactOpen(!siteContactOpen);
    }

    const togglePDFViewer = (src?: string) => {
        setPDFViewerDetails({ open: !pDFViewerDetails.open, uri: src || '' });
    }

    const siteMemo = useMemo(() => {
        return {
            toggleSiteMessage,
            togglePDFViewer,
            siteContactOpen,
            pDFViewerDetails
        }
    }, [pDFViewerDetails, siteContactOpen]);

    return (
        <SiteContext.Provider value={siteMemo}>
            {props.children}

            {pDFViewerDetails.open && (
                <PDFViewerModal visible={pDFViewerDetails.open} closeCallback={() => setPDFViewerDetails({...pDFViewerDetails, open: false })} />
            )}

            {siteContactOpen && (
                <CreateNewMessageModal visible={siteContactOpen} closeCallback={() => setSiteContactOpen(!siteContactOpen)} />
            )}
        </SiteContext.Provider>
    )
}

const useSite = () => useContext(SiteContext);

export { SiteContext, useSite };

export default SiteProvider